<ng-container>
  <div>
    <div id="tooltip-header" class="p-1">
      {{ absence | getAbsenceTimelineCardTitle | async }}
    </div>

    <nz-divider class="mt-1 mb-2"></nz-divider>

    <div class="p-2">
      <div class="mb-2">
        <div class="title">{{ 'page.absences.lbl_date_from' | translate }}</div>
        <div class="value">
          <span class="fw-normal">
            {{ absence.absentFrom | localizedDateTimeFormat }}
          </span>
        </div>
      </div>
      <div class="mb-2">
        <div class="title">
          {{ 'page.absences.lbl_date_until' | translate }}
        </div>
        <div class="value">
          <span class="fw-normal">
            {{ absence.absentTo | localizedDateTimeFormat }}
          </span>
        </div>
      </div>
      @if (absence?.remark) {
        <div class="mb-2">
          <div class="title">{{ 'general.comment' | translate }}</div>
          <div class="value">
            {{ absence.remark }}
          </div>
        </div>
      }
      <div class="mb-2">
        <div class="title">{{ 'page.absences.lbl_state' | translate }}</div>
        <nz-tag [nzColor]="'green'" class="mt-1">
          {{ 'enum.absence_state.' + absence.status | translate }}
        </nz-tag>
      </div>
    </div>
  </div>
</ng-container>
